//#region Imports
import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import AdmonWarehouseTable from '../components/Tables/AdmonWarehouseTable';
//#endregion

function InventoryAdmon() {
  const { titleInventoryString } = useTranslationHook();

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <div className='datatable'><AdmonWarehouseTable /></div>
    </div>
  );
}

export default InventoryAdmon;
